import { render, staticRenderFns } from "./SageNominalCodeSettings.vue?vue&type=template&id=2bb23102&scoped=true&"
import script from "./SageNominalCodeSettings.vue?vue&type=script&lang=js&"
export * from "./SageNominalCodeSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb23102",
  null
  
)

export default component.exports